import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import styles from "./EnrollmentTrendChart.module.css";
import { SkeletonBarGroup } from "../Skeleton";


const EnrollmentTrendChart = ({ 
  data = [], 
  title = "Monthly Enrollment Trend",
  enrolledLabel = "Enrolled",
  isLoading = false
}) => {
  const chartData = data;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className={styles.tooltip}>
          <p className={styles.tooltipLabel}>{label}</p>
          {payload.map((entry, index) => (
            <p key={index} className={styles.tooltipItem} style={{ color: entry.color }}>
              {`${enrolledLabel} Patient: ${entry.value}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className={styles.chartContainer}>
      {title && <h3 className={styles.chartTitle}>{title}</h3>}
      {isLoading ? (
        <div className={styles.chartSkeleton}>
          <SkeletonBarGroup
            count={6}
            heights={["40%", "48%", "56%", "64%", "72%", "80%"]}
          />
        </div>
      ) : (
      <ResponsiveContainer width="100%" height={210}>
        <BarChart data={chartData} margin={{ top: 28, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="month" 
            tick={{ fontSize: 12, fill: "#6b7280" }}
            axisLine={{ stroke: "#e5e7eb" }}
          />
          <YAxis 
            tick={{ fontSize: 12, fill: "#6b7280" }}
            axisLine={{ stroke: "#e5e7eb" }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend 
            wrapperStyle={{ paddingTop: "20px" }}
            iconType="square"
          />
          <Bar 
            dataKey="enrolled" 
            name={enrolledLabel}
            fill="#16a249" 
            radius={[4, 4, 0, 0]}
            label={{ position: "top", fill: "#111827", fontSize: 12, offset: 6 }}
          />
        </BarChart>
      </ResponsiveContainer>
      )}
    </div>
  );
};

export default EnrollmentTrendChart;

